import { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import EconoJournalLogo from "../../components/EconoJournalLogo";
import { showPopup } from "../../utils/popup";

const Login = () => {
  const [password, setPassword] = useState("");
  const { login } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  const from = location.state?.from?.pathname || "/dashboard";

  const handleLogin = (e) => {
    e.preventDefault();
    if (login(password)) {
      navigate(from, { replace: true });
    } else {
      showPopup("La contraseña ingresada no es correcta.", {
        title: "No se pudo iniciar sesión",
        type: "error",
      });
    }
  };

  return (
    <div className="container">
      <EconoJournalLogo className="logoECJ" />

      <form onSubmit={handleLogin}>
        <input
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          placeholder="Password"
        />
        <button type="submit">Entrar</button>
      </form>
    </div>
  );
};

export default Login;
